/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteTempoIntegrationInput = {
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type DeleteTempoIntegrationMutationVariables = {
    input: DeleteTempoIntegrationInput;
};
export type DeleteTempoIntegrationMutationResponse = {
    readonly deleteTempoIntegration: {
        readonly company: {
            readonly id: string;
            readonly tempoOauthTokenApplied: boolean | null;
            readonly tempoOauthClientId: string | null;
            readonly tempoOauthClientSecret: string | null;
        } | null;
    } | null;
};
export type DeleteTempoIntegrationMutation = {
    readonly response: DeleteTempoIntegrationMutationResponse;
    readonly variables: DeleteTempoIntegrationMutationVariables;
};



/*
mutation DeleteTempoIntegrationMutation(
  $input: DeleteTempoIntegrationInput!
) {
  deleteTempoIntegration(input: $input) {
    company {
      id
      tempoOauthTokenApplied
      tempoOauthClientId
      tempoOauthClientSecret
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteTempoIntegrationInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteTempoIntegrationPayload",
    "kind": "LinkedField",
    "name": "deleteTempoIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tempoOauthTokenApplied",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tempoOauthClientId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tempoOauthClientSecret",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteTempoIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteTempoIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "DeleteTempoIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteTempoIntegrationMutation(\n  $input: DeleteTempoIntegrationInput!\n) {\n  deleteTempoIntegration(input: $input) {\n    company {\n      id\n      tempoOauthTokenApplied\n      tempoOauthClientId\n      tempoOauthClientSecret\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'd1971c189ad87af163cacf503b31ffe7';
export default node;
